<template>
  <div class="">

    <Head />


    <div class="main shiftSchedule">
      <AccesskeyLink target="accesskey_c" accesskey="c" aria-label="跳到中央內容區塊">
        :::
      </AccesskeyLink>

      <!-- 毛毛蟲 -->
      <nav aria-label="breadcrumb" class="breadcrumb_box">
        <div class="container">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a href="#" :title="$t('首頁')">{{ $t('首頁') }}</a></li>
            <li class="breadcrumb-item active" aria-current="page">{{ $t('管理志工班表') }}</li>
          </ol>
        </div>
      </nav>


      <div class="shiftSchedule_box">

        <div class="container">

          <div class="title_box">
            <h2>{{ scheduleName || $t('管理志工班表') }}</h2>
            <p class="text-muted mt-2">{{ $t('管理者模式') }}</p>
            <div v-if="scheduleOpenStatus === 'notOpen'" class="schedule_status_notice notice_warning">
              {{ $t('未開放排班') }}
            </div>
            <div v-else-if="scheduleOpenStatus === 'closed'" class="schedule_status_notice notice_closed">
              {{ $t('排班已截止') }}
            </div>
          </div>

          <div class="schedule">

            <!-- 圖示說明 -->
            <ul class="iconItems_box">
              <li v-for="(item, index) in iconItems" :key="index">
                <img :src="item.src" :alt="item.title">
                <p>{{ item.title }}</p>
              </li>
            </ul>

            <!-- 排班表 -->
            <div class="schedule_fixed">

              <!-- 左側固定姓名欄 -->
              <div class="name_wrapper">
                <table class="name_table">
                  <thead>
                    <tr>
                      <th class="name">
                        {{ $t('志工姓名') }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="user in expandedUsers" :key="user.csvId + '-' + user.rowType">
                      <td v-if="user.rowType === 'schedule'" class="name" rowspan="2">
                        <div class="group">
                          <p>{{ user.name }}</p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>

              </div>

              <!-- 右側日期表格 -->
              <div class="date_wrapper">
                <table class="schedule_table">
                  <thead>
                    <tr>
                      <th v-for="day in daysInPeriod" :key="day.dateStr" :class="day.isHoliday ? 'holiday' : 'weekday'">
                        <div class="day_box">
                          <div>{{ day.day }}</div>
                          <div class="week">（{{ day.weekday }}）</div>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="user in expandedUsers" :key="user.csvId + '-' + user.rowType"
                      :class="user.rowType === 'checkin' ? 'checkin_status_row' : ''">
                      <!-- 排班選擇格 -->
                      <template v-if="user.rowType === 'schedule'">
                        <td v-for="day in daysInPeriod" :key="day.dateStr" class="date"
                          :class="day.isHoliday ? 'holiday' : 'weekday'">
                          <div class="date_box">
                            <button class="date_btn" 
                              :class="{ disabled: isDisabled(user.csvId, day.dateStr), 'date_btn_no_edit': scheduleOpenStatus !== 'open' }" 
                              :disabled="isDisabled(user.csvId, day.dateStr) && !(canEditRemark && hasSchedule(user.csvId, day.dateStr)) && !hasRemark(user.csvId, day.dateStr)"
                              @click.stop="openPicker(user.csvId, day.dateStr, $event)">
                              <img :src="getDayImg(user.csvId, day.dateStr)" />
                              <span v-if="hasRemark(user.csvId, day.dateStr)" class="remark_marker" aria-label="有備註" title="有備註"></span>
                            </button>
                          </div>
                        </td>
                      </template>
                      <!-- 打卡狀態格 -->
                      <template v-else>
                        <td v-for="day in daysInPeriod" :key="'checkin-' + day.dateStr" class="checkin_status"
                          :class="day.isHoliday ? 'holiday' : 'weekday'">
                          <div class="checkin_box">
                            <!-- 上午打卡狀態 -->
                            <div class="shift_checkin" v-if="needCheckIn(user.csvId, day.dateStr, 'morning')">
                              <img v-if="hasCheckedIn(user.csvId, day.dateStr, 'morning')" 
                                src="/img/workdays_green.svg" 
                                :alt="getCheckInTimeAlt(user.csvId, day.dateStr, 'morning')"
                                :title="getCheckInTimeAlt(user.csvId, day.dateStr, 'morning')" />
                              <img v-else-if="isOverdueCheckIn(user.csvId, day.dateStr, 'morning')" 
                                src="/img/none_grey.svg" 
                                :alt="$t('逾時未打卡')"
                                :title="$t('逾時未打卡')" />
                            </div>
                            <!-- 下午打卡狀態 -->
                            <div class="shift_checkin" v-if="needCheckIn(user.csvId, day.dateStr, 'afternoon')">
                              <img v-if="hasCheckedIn(user.csvId, day.dateStr, 'afternoon')" 
                                src="/img/workdays_green.svg" 
                                :alt="getCheckInTimeAlt(user.csvId, day.dateStr, 'afternoon')"
                                :title="getCheckInTimeAlt(user.csvId, day.dateStr, 'afternoon')" />
                              <img v-else-if="isOverdueCheckIn(user.csvId, day.dateStr, 'afternoon')" 
                                src="/img/none_grey.svg" 
                                :alt="$t('逾時未打卡')"
                                :title="$t('逾時未打卡')" />
                            </div>
                          </div>
                        </td>
                      </template>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- 班別選擇 Picker -->
              <div v-if="picker.visible" class="shift_picker" :style="{ top: picker.y + 'px', left: picker.x + 'px' }">
                <div v-for="opt in (scheduleOpenStatus === 'open' ? getFilteredShiftOptions() : [])" :key="opt.id" class="option" @click="selectShift(opt.id)">
                  <img :src="opt.img" />
                  <div>{{ opt.text }}</div>
                </div>
                <div v-if="canEditRemark && hasSchedule(picker.userId, picker.day)" class="option remark_edit_option" @click.stop="editRemark">
                  <span class="remark_edit_icon">✎</span>
                  <div>{{ $t('編輯備註') }}</div>
                </div>
                <div v-if="currentRemark" class="picker_remark">
                  <strong>{{ $t('備註') }}</strong>
                  <span>{{ currentRemark }}</span>
                </div>
              </div>

            </div>

            <div class="text_box">
              <p>
                {{ $t('注意事項') }}
                <br>
                {{ $t('管理者模式：可不受時間限制調整所有志工的排班，但依然會照志工的可服勤時段有所限制') }}
                <br>
                {{ $t('星期四至星期二上午9時至12時及下午1時至4時，採兩班制') }}
                <br>
                *{{ $t('如遇天然災害，依本市公佈放假標準為原則，不另行通知') }}
              </p>
            </div>

            <div class="btn_box">
              <button class="send_btn" @click="saveSchedule" :disabled="scheduleOpenStatus !== 'open'">{{ $t('儲存') }}</button>
            </div>

          </div>

        </div>


      </div>

    </div>

    <Footer />

  </div>
</template>

<script>
import Head from '@/components/Head.vue'
import Footer from '@/components/Footer.vue';
import Swal from 'sweetalert2';

import AccesskeyLink from '@/views/AccesskeyLink.vue'



export default {

  name: 'VolunteerScheduleManager',
  components: {
    Head,
    Footer,
    AccesskeyLink,
  },

  data() {
    return {

      scheduleName: '',
      csId: 0,
      token: '',
      managerMId: 0,
      startDate: null,
      endDate: null,
      openSchedulingStartTime: null,
      openSchedulingEndTime: null,
      
      // 儲存每個志工的可服勤時段 格式: { csvId: ["Mon_1", "Tue_1", "Tue_2"] }
      volunteerAvailableSchedules: {},

      iconItems: [],

      shiftOptions: [
        {
          id: 'morning',
          text: '',
          img: require('/public/img/AM.svg'),
        },
        {
          id: 'afternoon',
          text: '',
          img: require('/public/img/PM.svg'),
        },
        {
          id: 'fullday',
          text: '',
          img: require('/public/img/ALL.svg'),
        },
      ],

      users: [],

      // 排班記錄 格式: { 'csvId_date': 'shiftType' }
      schedules: {},
      remarks: {},
      canEditRemark: false,

      // 打卡記錄 格式: [{ csvId, scheduleDate, shiftType, hasCheckedIn, checkInTime }]
      checkInStatus: [],

      picker: {
        visible: false,
        userId: null,
        day: null,
        x: 0,
        y: 0
      },

    }
  },

  async mounted() {
    document.addEventListener('click', this.closePicker)

    // 初始化翻譯文字
    this.iconItems = [
      { src: require('/public/img/AM.svg'), title: this.$t('上午場') },
      { src: require('/public/img/PM.svg'), title: this.$t('下午場') },
      { src: require('/public/img/ALL.svg'), title: this.$t('全日') }
    ]
    this.shiftOptions[0].text = this.$t('上午場')
    this.shiftOptions[1].text = this.$t('下午場')
    this.shiftOptions[2].text = this.$t('全日')

    // 從路由參數取得 csId、token 和 managerMId
    this.csId = parseInt(this.$route.params.csId)
    this.token = this.$route.query.token
    this.managerMId = parseInt(this.$route.query.managerMId)

    if (!this.csId || !this.token || !this.managerMId) {
      await Swal.fire({
        icon: 'error',
        title: this.$t('錯誤'),
        text: this.$t('無效的存取方式')
      })
      window.location.href = '/'
      return
    }

    // 驗證token並載入排班資料
    await this.loadScheduleDetail()

    // 寬度等於表格寬度
    this.$nextTick(() => {
      this.syncRowHeights()
      window.addEventListener('resize', this.syncRowHeights)

      const name = this.$el.querySelector('.name_wrapper')
      const date = this.$el.querySelector('.date_wrapper')
      const container = this.$el.querySelector('.shiftSchedule_box .container')

      if (!name || !date || !container) return

      const totalWidth = name.offsetWidth + date.offsetWidth + 25

      container.style.maxWidth = totalWidth + 'px'
    })
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closePicker)
    window.removeEventListener('resize', this.syncRowHeights)
  },

  computed: {
    daysInPeriod() {
      if (!this.startDate || !this.endDate) return []
      
      const days = []
      const start = new Date(this.startDate)
      const end = new Date(this.endDate)
      
      for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
        const dateStr = this.formatDate(d)
        const dayNum = d.getDate()
        const weekday = ['日', '一', '二', '三', '四', '五', '六'][d.getDay()]
        const isHoliday = d.getDay() === 0 || d.getDay() === 6
        
        days.push({ dateStr, day: dayNum, weekday, isHoliday })
      }
      
      return days
    },
    
    scheduleOpenStatus() {
      const now = new Date()
      const openStart = this.openSchedulingStartTime ? new Date(this.openSchedulingStartTime) : null
      const openEnd = this.openSchedulingEndTime ? new Date(this.openSchedulingEndTime) : null
      if (!openStart || !openEnd) return 'open'
      if (now < openStart) return 'notOpen'
      if (now >= openStart && now <= openEnd) return 'open'
      return 'closed'
    },

    // 展開使用者列表，每個使用者產生兩個項目（排班列和打卡列）
    expandedUsers() {
      const result = []
      this.users.forEach(user => {
        result.push({ ...user, rowType: 'schedule' })
        result.push({ ...user, rowType: 'checkin' })
      })
      return result
    },
    currentRemark() {
      if (!this.picker.userId || !this.picker.day) return ''
      return this.remarks[`${this.picker.userId}_${this.picker.day}`] || ''
    }
  },

  methods: {

    async loadScheduleDetail() {
      try {
        const apiUrl = `${this.$store.state.src}${this.$store.state.subDirectory}/ChachaStaffVolunteer/GetScheduleDetailForManager`;
        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            csId: this.csId,
            token: this.token,
            managerMId: this.managerMId,
            accountType: 'Volunteer'
          })
        })

        const result = await response.json()
        if (!result.ok) {
          await Swal.fire({
            icon: 'error',
            title: this.$t('載入失敗'),
            text: result.message || this.$t('載入失敗')
          })
          window.location.href = '/'
          return
        }

        // 設定基本資料
        this.scheduleName = result.scheduling.scheduleName
        this.startDate = result.scheduling.startDate
        this.endDate = result.scheduling.endDate
        this.openSchedulingStartTime = result.scheduling.openSchedulingStartTime || null
        this.openSchedulingEndTime = result.scheduling.openSchedulingEndTime || null
        this.canEditRemark = !!result.canEditRemark

        // 建立使用者列表並儲存每個志工的可服勤時段
        this.users = result.allStaffSchedules.map(staff => {
          // 解析可服勤時段
          let availableSchedule = []
          if (staff.availableSchedule) {
            try {
              availableSchedule = JSON.parse(staff.availableSchedule)
            } catch (e) {
              console.error(`解析 ${staff.name} 的可服勤時段失敗:`, e)
              availableSchedule = []
            }
          }
          
          // 儲存到對應的 csvId
          this.volunteerAvailableSchedules[staff.csvId] = availableSchedule

          return {
            csvId: staff.csvId,
            name: staff.name
          }
        })

        // 載入所有志工的排班記錄
        result.allStaffSchedules.forEach(staff => {
          staff.schedules.forEach(schedule => {
            const formattedDate = this.formatDate(schedule.scheduleDate)
            const key = `${staff.csvId}_${formattedDate}`
            this.$set(this.schedules, key, schedule.shiftType)
            if (schedule.remark) this.$set(this.remarks, key, schedule.remark)
          })
        })

        // 載入打卡狀態
        await this.loadCheckInStatus()

      } catch (error) {
        console.error('載入排班資料失敗:', error)
        await Swal.fire({
          icon: 'error',
          title: this.$t('載入失敗'),
          text: this.$t('載入排班資料失敗，請稍後再試')
        })
        window.location.href = '/'
      }
    },

    async saveSchedule() {
      if (this.scheduleOpenStatus !== 'open') return

      const result = await Swal.fire({
        icon: 'question',
        title: this.$t('確認儲存'),
        text: this.$t('確定要儲存所有志工的排班嗎？'),
        showCancelButton: true,
        confirmButtonText: this.$t('確定儲存'),
        cancelButtonText: this.$t('取消'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33'
      })
      
      if (!result.isConfirmed) {
        return
      }

      try {
        // 收集所有志工的排班記錄並分別儲存
        for (const user of this.users) {
          const userSchedules = []
          Object.keys(this.schedules).forEach(key => {
            const [csvId, date] = key.split('_')
            if (parseInt(csvId) === user.csvId) {
              const shiftType = this.schedules[key]
              userSchedules.push({
                scheduleDate: date,
                shiftType: shiftType
              })
            }
          })

          const apiUrl = `${this.$store.state.src}${this.$store.state.subDirectory}/ChachaStaffVolunteer/SaveScheduleForManager`;
          const response = await fetch(apiUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              csId: this.csId,
              csvId: user.csvId,
              token: this.token,              managerMId: this.managerMId,              schedules: userSchedules,
              isSubmitted: true // 管理者直接標記為已送出
            })
          })

          const saveResult = await response.json()
          if (!saveResult.ok) {
            await Swal.fire({
              icon: 'error',
              title: this.$t('儲存失敗'),
              text: `${this.$t('儲存')} ${user.name} ${this.$t('的排班失敗')}: ${saveResult.message}`
            })
            return
          }
        }

        await Swal.fire({
          icon: 'success',
          title: this.$t('儲存成功'),
          text: this.$t('所有志工的排班已成功儲存'),
          showConfirmButton: true,
          confirmButtonText: this.$t('確定')
        })

      } catch (error) {
        console.error('儲存失敗:', error)
        await Swal.fire({
          icon: 'error',
          title: this.$t('儲存失敗'),
          text: this.$t('儲存失敗請稍後再試')
        })
      }
    },

    // 班別 picker
    openPicker(userId, day, event) {
      // 檢查該日期可選擇的班別
      const availableShifts = this.getAvailableShifts(userId, day)
      if (availableShifts.length === 0 &&
          !(this.canEditRemark && this.hasSchedule(userId, day)) &&
          !this.hasRemark(userId, day)) {
        return // 沒有可選的班別，不開啟選擇器
      }
      
      this.picker = { visible: true, userId, day, x: event.clientX, y: event.clientY }
    },
    
    // 取得過濾後的班別選項（只顯示可選的）
    getFilteredShiftOptions() {
      if (!this.picker.userId || !this.picker.day) return []
      
      const availableShifts = this.getAvailableShifts(this.picker.userId, this.picker.day)
      return this.shiftOptions.filter(opt => availableShifts.includes(opt.id))
    },
    
    selectShift(shiftId) {
      const key = `${this.picker.userId}_${this.picker.day}`
      this.$set(this.schedules, key, shiftId)

      this.picker.visible = false
      this.picker.userId = null
      this.picker.day = null

      this.$nextTick(this.syncRowHeights)
    },

    // 取得某志工某日期可選擇的班別（根據可服勤時段）
    getAvailableShifts(csvId, dateStr) {
      const date = new Date(dateStr)
      const dayOfWeek = date.getDay() // 0=日, 1=一, 2=二, ..., 6=六
      
      // 將數字星期轉換為中文
      const dayMapping = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
      const dayName = dayMapping[dayOfWeek]
      
      // 取得該志工的可服勤時段
      const availableSchedule = this.volunteerAvailableSchedules[csvId] || []
      
      // 檢查該星期幾的可服勤時段
      const hasMorning = availableSchedule.some(slot => 
        slot === `${dayName}-09時-12時` || slot === `${dayName.replace('星期', '')}_1`
      )
      const hasAfternoon = availableSchedule.some(slot => 
        slot === `${dayName}-13時-16時` || slot === `${dayName.replace('星期', '')}_2`
      )
      
      const available = []
      
      // 根據可服勤時段決定可選的班別
      if (hasMorning && hasAfternoon) {
        // 上午和下午都可以 → 可選 AM, PM, ALL
        available.push('morning', 'afternoon', 'fullday')
      } else if (hasMorning) {
        // 只有上午可以 → 只能選 AM
        available.push('morning')
      } else if (hasAfternoon) {
        // 只有下午可以 → 只能選 PM
        available.push('afternoon')
      }
      
      return available
    },
    
    getShiftImg(csvId, day) {
      const key = `${csvId}_${day}`
      const shiftId = this.schedules[key]
      const opt = this.shiftOptions.find(o => o.id === shiftId)
      return opt ? opt.img : null
    },
    hasRemark(csvId, day) {
      return !!this.remarks[`${csvId}_${day}`]
    },
    hasSchedule(csvId, day) {
      return !!this.schedules[`${csvId}_${day}`]
    },
    async editRemark() {
      const key = `${this.picker.userId}_${this.picker.day}`
      const result = await Swal.fire({
        title: this.$t('編輯備註'),
        input: 'textarea',
        inputValue: this.remarks[key] || '',
        inputAttributes: { maxlength: '1000', 'aria-label': this.$t('備註') },
        showCancelButton: true,
        confirmButtonText: this.$t('儲存'),
        cancelButtonText: this.$t('取消'),
        inputValidator: value => value.length > 1000 ? this.$t('備註不可超過 1000 字') : undefined
      })
      if (!result.isConfirmed) return

      const apiUrl = `${this.$store.state.src}${this.$store.state.subDirectory}/ChachaStaffVolunteer/SaveScheduleRemarkForManager`
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          csId: this.csId,
          csvId: this.picker.userId,
          scheduleDate: this.picker.day,
          shiftType: this.schedules[key] || '',
          token: this.token,
          managerMId: this.managerMId,
          remark: result.value || ''
        })
      })
      const saveResult = await response.json()
      if (!saveResult.ok) {
        await Swal.fire({ icon: 'error', title: this.$t('儲存失敗'), text: saveResult.message })
        return
      }
      if (saveResult.remark) this.$set(this.remarks, key, saveResult.remark)
      else this.$delete(this.remarks, key)
      this.picker.visible = false
      await Swal.fire({ icon: 'success', title: this.$t('儲存成功'), showConfirmButton: false, timer: 1200 })
    },

    getDayImg(csvId, day) {
      // 有班別 → 優先顯示班別
      const shiftImg = this.getShiftImg(csvId, day)
      if (shiftImg) return shiftImg

      // 不能選 → 顯示鎖定圖
      if (this.isDisabled(csvId, day)) {
        return require('/public/img/none_grey.svg')
      }

      // 預設 → 顯示 +
      return require('/public/img/add_black.svg')
    },


    formatDate(date) {
      const d = typeof date === 'string' ? new Date(date) : date
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${y}-${m}-${day}`
    },

    // 格子 picker視窗開關
    closePicker() { this.picker.visible = false },


    // 判斷某志工某一天是否不能選
    isDisabled(csvId, dateStr) {
      const date = new Date(dateStr)

      // 固定規則：每週三不能選 (getDay() === 3)
      if (date.getDay() === 3) return true

      // 檢查該日期是否有任何可選的班別（根據可服勤時段）
      const availableShifts = this.getAvailableShifts(csvId, dateStr)
      if (availableShifts.length === 0) return true

      // 可選
      return false
    },

    // 同步左右表格行高
    syncRowHeights() {
      this.$nextTick(() => {
        const nameRows = this.$el.querySelectorAll('.name_table tbody tr')
        const scheduleRows = this.$el.querySelectorAll('.schedule_table tbody tr')
        nameRows.forEach((row, i) => {
          const scheduleRow = scheduleRows[i]
          if (scheduleRow) {
            const maxHeight = Math.max(row.offsetHeight, scheduleRow.offsetHeight)
            row.style.height = maxHeight + 'px'
            scheduleRow.style.height = maxHeight + 'px'
          }
        })
        const nameHead = this.$el.querySelector('.name_table thead tr')
        const scheduleHead = this.$el.querySelector('.schedule_table thead tr')
        if (nameHead && scheduleHead) {
          const maxHeadHeight = Math.max(nameHead.offsetHeight, scheduleHead.offsetHeight)
          nameHead.style.height = maxHeadHeight + 'px'
          scheduleHead.style.height = maxHeadHeight + 'px'
        }
      })
    },

    // 載入打卡狀態
    async loadCheckInStatus() {
      try {
        const apiUrl = `${this.$store.state.src}${this.$store.state.subDirectory}/ChachaStaffVolunteer/GetCheckInStatusForManager`;
        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            csId: this.csId,
            token: this.token,
            managerMId: this.managerMId
          })
        })

        const result = await response.json()
        if (result.ok) {
          this.checkInStatus = result.checkInStatus
        }
      } catch (error) {
        console.error('載入打卡狀態失敗:', error)
      }
    },

    // 判斷是否需要顯示打卡狀態（有排班記錄）
    needCheckIn(csvId, dateStr, shiftType) {
      const key = `${csvId}_${dateStr}`
      const schedule = this.schedules[key]
      if (!schedule) return false
      
      // morning = 上午, afternoon = 下午, fullday = 全日
      if (shiftType === 'morning') {
        return schedule === 'morning' || schedule === 'fullday'
      } else if (shiftType === 'afternoon') {
        return schedule === 'afternoon' || schedule === 'fullday'
      }
      return false
    },

    // 判斷是否已打卡
    hasCheckedIn(csvId, dateStr, shiftType) {
      const checkIn = this.checkInStatus.find(c => 
        c.csvId === csvId &&
        this.formatDate(c.scheduleDate) === dateStr
      )
      if (!checkIn) return false
      
      // 根據 shiftType 檢查對應的時間欄位
      if (shiftType === 'morning') {
        return checkIn.morningCheckInTime != null && checkIn.morningCheckOutTime != null
      } else if (shiftType === 'afternoon') {
        return checkIn.afternoonCheckInTime != null && checkIn.afternoonCheckOutTime != null
      }
      return false
    },

    // 判斷是否逾時未打卡（今天之前的日期且未打卡）
    isOverdueCheckIn(csvId, dateStr, shiftType) {
      const date = new Date(dateStr)
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      
      // 只有今天之前的日期才算逾時
      if (date >= today) return false
      
      // 有排班但未打卡
      return this.needCheckIn(csvId, dateStr, shiftType) && !this.hasCheckedIn(csvId, dateStr, shiftType)
    },

    // 取得打卡時間作為 alt 文字
    getCheckInTimeAlt(csvId, dateStr, shiftType) {
      const checkIn = this.checkInStatus.find(c => 
        c.csvId === csvId &&
        this.formatDate(c.scheduleDate) === dateStr
      )
      if (!checkIn) return ''
      
      // 根據 shiftType 取得對應的時間
      let checkInTime = null
      let checkOutTime = null
      
      if (shiftType === 'morning') {
        checkInTime = checkIn.morningCheckInTime
        checkOutTime = checkIn.morningCheckOutTime
      } else if (shiftType === 'afternoon') {
        checkInTime = checkIn.afternoonCheckInTime
        checkOutTime = checkIn.afternoonCheckOutTime
      }
      
      if (checkInTime && checkOutTime) {
        const timeIn = new Date(checkInTime)
        const timeOut = new Date(checkOutTime)
        return `打卡: ${String(timeIn.getHours()).padStart(2, '0')}:${String(timeIn.getMinutes()).padStart(2, '0')} - ${String(timeOut.getHours()).padStart(2, '0')}:${String(timeOut.getMinutes()).padStart(2, '0')}`
      }
      return ''
    },

  }
}

</script>

<style scoped>
.schedule_status_notice {
  display: inline-block;
  padding: 6px 18px;
  border-radius: 4px;
  font-size: 15px;
  font-weight: 600;
  margin-top: 10px;
}

.notice_warning {
  background-color: #ffc107;
  color: #333;
}

.notice_closed {
  background-color: #dc3545;
  color: white;
}

.date_btn_no_edit {
  cursor: not-allowed;
  opacity: 0.7;
}

.date_btn { position: relative; }
.remark_marker {
  position: absolute;
  top: 3px;
  right: 3px;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #dc3545;
  box-shadow: 0 0 0 2px #fff;
}
.remark_edit_option { border-top: 1px solid #ddd; }
.remark_edit_icon {
  flex: 0 0 20px;
  width: 20px;
  height: 20px;
  margin-right: 3px;
  font-size: 18px;
  line-height: 20px;
  text-align: center;
}
.picker_remark {
  position: absolute;
  top: 0;
  left: calc(100% + 6px);
  min-width: 180px;
  max-width: 300px;
  padding: 12px;
  box-sizing: border-box;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 5px;
  box-shadow: 2px 2px 2px #00000020;
  white-space: pre-wrap;
  word-break: break-word;
  text-align: left;
}
.picker_remark strong { display: block; margin-bottom: 4px; }

.send_btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background-color: #9e9e9e;
}

/* 打卡狀態列樣式 */
.checkin_status {
  padding: 8px;
  text-align: center;
}

.checkin_box {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0px;
  min-height: 40px;
  background-color: #efefef;
  margin: 0 3px;
}

.shift_checkin {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
}

.shift_checkin img {
  width: 24px;
  height: 24px;
  cursor: help;
}
</style>
